import TextBlock from './textBlock-TEMPLATE_VERSION'

export default TextBlock
